/* eslint camelcase: 0 */
import { UpstreamGatewayBase } from './base'
import { toMediaProps } from './translator/media'
import { toUpstreamQueryProps, toQueryProps } from './translator/query'
import { toOptionsProps } from './translator/options'
import { GetMedia, FetchMedia } from '@/infrastructure/network/Upstream/requests/media'
import { IMediaProps, EmptyMediaPropsFactory } from '@/entities/Upstream/Media'
import { IQueryProps } from '@/entities/Query'

export default class Media extends UpstreamGatewayBase {
  async GetMedia(id: string): Promise<IMediaProps> {
    const { media } = await this.apiClient.request(new GetMedia(id))
    return media ? toMediaProps(media) : EmptyMediaPropsFactory()
  }

  async FetchMedia(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchMedia(toUpstreamQueryProps(query)))
    return {
      items: response.media.map((prop) => toMediaProps(prop)),
      query: toQueryProps(response.query),
      options: toOptionsProps(response.query)
    }
  }
}
